module.exports = __webpack_public_path__ + "static/img/shihuacao-active.bfe6489.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shihuacao-active.png
// module id = pcYQ
// module chunks = 1